import { openLiveChat } from "../../lib/chat";
import {
  OLIVEUP_BUSINESS_HOURS,
  OLIVEUP_HELLO_EMAIL,
  OLIVEUP_MAILTO,
  OLIVEUP_PHONE_E164,
} from "../../lib/contact";
import { MessageCircle, Mail, Phone } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-foreground text-background relative overflow-hidden"
    >
      <div className="container-tight py-20 md:py-24 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5">
            <img
              src="/assets/olive-up-logo.png"
              alt="OliveUp"
              className="h-12 w-auto object-contain bg-background/90 rounded-xl px-3 py-1.5"
            />
          </div>
          <p className="mt-5 text-background/70 max-w-sm leading-relaxed">
            The fun-loving funding team. We help small businesses grow with
            flexible terms, personalized repayment plans, and a YES when others
            say no.
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-[#F5B82E]">
            Funding
          </h4>
          <ul className="mt-5 space-y-3 text-background/80">
            <li><a href="#funding" className="hover:text-[#F5B82E]">SBA Loans</a></li>
            <li><a href="#funding" className="hover:text-[#F5B82E]">Commercial Loans</a></li>
            <li><a href="#funding" className="hover:text-[#F5B82E]">Lines of Credit</a></li>
            <li><a href="#funding" className="hover:text-[#F5B82E]">Equipment Financing</a></li>
            <li><a href="#funding" className="hover:text-[#F5B82E]">Refinancing</a></li>
            <li><a href="#funding" className="hover:text-[#F5B82E]">Working Capital</a></li>
            <li><a href="#funding" className="hover:text-[#F5B82E]">Invoice Factoring</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-[#F5B82E]">
            Get in touch
          </h4>
          <ul className="mt-5 space-y-3 text-background/80">
            <li>
              <a href="https://www.getoliveup.com" target="_blank" rel="noopener noreferrer" data-testid="footer-website" className="hover:text-[#F5B82E]">
                www.getoliveup.com
              </a>
            </li>
            {OLIVEUP_PHONE_E164 ? (
              <>
                <li>
                  <a
                    href={`tel:${OLIVEUP_PHONE_E164}`}
                    data-testid="footer-call"
                    className="inline-flex items-center gap-1.5 hover:text-[#F5B82E] transition-colors"
                  >
                    <Phone className="h-4 w-4" />
                    Call us
                  </a>
                </li>
                <li>
                  <a
                    href={`sms:${OLIVEUP_PHONE_E164}`}
                    data-testid="footer-sms"
                    className="hover:text-[#F5B82E] transition-colors"
                  >
                    Text us
                  </a>
                </li>
              </>
            ) : null}
            <li>
              <button
                type="button"
                onClick={openLiveChat}
                data-testid="footer-chat"
                className="inline-flex items-center gap-1.5 font-semibold hover:text-[#F5B82E] transition-colors"
              >
                <MessageCircle className="h-4 w-4" />
                Live chat (fastest)
              </button>
            </li>
            <li>
              <a href={OLIVEUP_MAILTO} data-testid="footer-email" className="inline-flex items-center gap-1.5 hover:text-[#F5B82E] transition-colors">
                <Mail className="h-4 w-4" />
                {OLIVEUP_HELLO_EMAIL}
              </a>
            </li>
            <li className="text-background/60 text-sm pt-1">{OLIVEUP_BUSINESS_HOURS}</li>
          </ul>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#apply"
              data-testid="footer-apply-btn"
              className="inline-flex justify-center rounded-full bg-[#E07A5F] hover:bg-[#D1664A] text-white px-6 py-3 font-semibold transition-colors text-center"
            >
              Apply for funding
            </a>
            <button
              type="button"
              onClick={openLiveChat}
              data-testid="footer-chat-secondary"
              className="inline-flex justify-center items-center gap-2 rounded-full border border-background/30 px-6 py-3 font-semibold text-background hover:bg-background/10 transition-colors"
            >
              <MessageCircle className="h-4 w-4" />
              Chat instead
            </button>
          </div>
        </div>
      </div>

      <div className="border-t border-background/15">
        <div className="container-tight py-7 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-sm text-background/60">
          <p>© {year} OliveUp. All rights reserved.</p>
          <p className="max-w-2xl md:text-right leading-relaxed">
            Loan products are offered through OliveUp&apos;s lending partners
            subject to their approval, terms, and conditions. Not all applicants
            will qualify. All loan amounts and terms are subject to underwriting.
          </p>
        </div>
      </div>
    </footer>
  );
}
